import { config } from "./config";
import axios from "axios";

export const ServerService = {
  checkIsActive,
};
function checkIsActive() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.apiUrl)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
